import axios from "axios";
import React, { useEffect, useState } from "react";

const useDidMount = (func: Function) =>
    useEffect(() => {
        func();
    }, []);

const GET_RESULT_URL = "/apps/know-yourself/results";

const AppResultList: React.VFC = (props) => {
    const args = {
        headers: {
            "Content-Type": "application/json",
        },
        params: {
            //@ts-ignore
            customerId: window.shopifyParameters.customerId,
        },
    };

    const [resultList, setResultList] = useState(null);

    useDidMount(() => {
        axios.get(`${GET_RESULT_URL}.json`, args).then((res) => {
            setResultList(res.data);
        });
    });

    return (
        <>
            {!!resultList &&
                resultList.map((e, i) => (
                    <div key={i}>
                        <a href={e.link}>
                            <span>回答{resultList.length - i}</span> 日時：
                            {e.created_at}
                        </a>
                    </div>
                ))}
        </>
    );
};

export default AppResultList;
